import React from "react";

export const isEnterKey = (event: React.KeyboardEvent): boolean => {
  if (event.key.toLowerCase() === "enter") {
    return true;
  } else return false;
};
